module.exports = __webpack_public_path__ + "img/h3.7713bc83.jpg";